export default "__VITE_ASSET__CpAMQdAr__"